import { KpiCardSkeleton } from './KpiCardSkeleton';

export interface KpiSkeletonGridProps {
  /** Mesmo grid da linha real, para o layout não mudar ao sair do carregamento. */
  readonly gridClass: string;
  /** Quantidade de placeholders — espelha a quantidade de indicadores da linha. */
  readonly count: number;
}

/**
 * Grade de placeholders de uma linha de indicadores.
 *
 * As duas linhas de KPI da feature carregam da mesma forma e só diferem no grid e na
 * contagem, então a grade mora aqui: uma mudança no carregamento (animação, `aria-busy`,
 * estratégia de chave) acontece uma vez, não uma vez por linha.
 */
export function KpiSkeletonGrid({ gridClass, count }: KpiSkeletonGridProps) {
  return (
    <div className={gridClass}>
      {Array.from({ length: count }, (_, index) => `kpi-skeleton-${index}`).map(key => (
        <KpiCardSkeleton key={key} />
      ))}
    </div>
  );
}
